export default __webpack_public_path__ + "61de4600523fcba7d6c94a2c3d688660.png";